import Vue from 'vue'

Vue.filter('account', function({ email, firstName, lastName }) {
    return firstName && lastName ? `${email} (${firstName} ${lastName})` : email
})

Vue.filter('limits', function(count, unlimitedRights = false) {
    if (unlimitedRights) return '∞'

    return count || 0
})
